import React, { ReactNode } from 'react'
import { ThemeProvider, CssBaseline, createMuiTheme } from '@material-ui/core'
import 'fontsource-roboto'

export type RootProps = {
  children: ReactNode
}

const theme = createMuiTheme()

export default function Root (props: RootProps) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      {props.children}
    </ThemeProvider>
  )
}
